import ActionColumnRenderer from '../../../../app/Table/renderer/ActionColumnRenderer'
import Attendents from '../../../../../models/ReportModels/Attendents'
import moment from 'moment'

export default class AttendentsColumnRenderer extends ActionColumnRenderer<Attendents> {
    getColumns() {
        return [
            {
                name: 'Name',
                selector: 'name',
                format: (row: {}) => {
                    if (row instanceof Attendents) {
                        const reason = row.getName()
                        if (reason !== null) return reason
                        else return "--"
                    }
                },
            },
            {
                name: 'Mobile',
                selector: 'mobile',
            },
            {
                name: 'Date Of Birth',
                selector: 'dob',
                format: (row: {}) => {
                    if (row instanceof Attendents) {
                        const dob = row.getDOB()
                        if (dob !== null) return moment(dob).format('LL')
                    }
                },
            },
            {
                name: 'Actions',
                selector: '_id',
                grow: 0,
                width: '180px',
                cell: this.renderActionColumn,
            },
        ]
    }
}
